import Vue from 'vue'
import Vuex from 'vuex'

import defaultStates from '@/vuex/defaultStates'
import getters from '@/vuex/getters'
import mutations from '@/vuex/mutations'
import actions from '@/vuex/actions'
import modules from '@/vuex/modules'
import mixpanelContextPlugin from '@/vuex/plugins/mixpanel.context.plugin'
import mixpanelQueuePlugin from '@/vuex/plugins/mixpanel.queue.plugin'
import wordCloudModule from '@/vuex/modules/wordcloud.module'
import spellcheckerPlugin from '@/vuex/plugins/spellchecker.plugin'

import kvSyncPlugins from '@/vuex/plugins/kvSync'
import subscribeCanvasBlockPluginLegacy from '@/vuex/plugins/canvasBlock.plugin'
import historyPlugin from '@/vuex/modules/history/history.plugin'
import rememberSettingPlugin from '@/vuex/plugins/rememberSetting.plugin'
import remoteControlPlugin from '@/vuex/plugins/remote-control.plugin'
import readinessCheckerStalePlugin from '@/vuex/plugins/readiness-checker-stale.plugin'
import planModule from '@/vuex/modules/plan.module'
import slideSettingModule from '@/vuex/modules/slide/slide.setting.module'
import routePrefetchPlugin from '@/vuex/plugins/route-prefetch.plugin'
import localStorageABTestPlugin from '@/vuex/plugins/local-storage-abtest.plugin'
import marketplaceRedeemPlugin from '@/vuex/plugins/marketplace-redeem.plugin'
import marketplaceCaptureRenderHoldPlugin from '@/vuex/plugins/marketplace-capture-render-hold.plugin'
import featureTogglesModule from './modules/featureToggles.module'
import skipSlideModule from '@/vuex/modules/skip-slide/skip-slide.module'
import audioModule from './modules/presentation/audio.module'
import embeddablePlugin from '@/vuex/modules/embeddable/embeddable.plugin'
import { isEmbedded } from '@/vuex/modules/embeddable/embeddable.utils'
import embedAppPlugin from '@/vuex/modules/embed-app/embed-app.plugin'
import slideAttributesCachePurgePlugin from '@/vuex/modules/slide-attributes/slide-attributes.cache-purge.plugin'
import htmlSlideCachePurgePlugin from '@/vuex/modules/slide-attributes/html-slide-cache-purge.plugin'
import imageCreditNotesPlugin from '@/vuex/plugins/image-credit-notes.plugin'
import presetModule from './modules/preset.module'
import appLoggingPlugin from '@/vuex/plugins/app-logging.plugin'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: defaultStates,
  getters,
  mutations,
  actions,
  modules,
  plugins: [
    mixpanelContextPlugin,
    mixpanelQueuePlugin,
    ...featureTogglesModule.plugins,
    wordCloudModule.plugins.subscribeSlideVersionPlugin,
    ...kvSyncPlugins,
    subscribeCanvasBlockPluginLegacy,
    spellcheckerPlugin,
    historyPlugin,
    rememberSettingPlugin,
    remoteControlPlugin,
    readinessCheckerStalePlugin,
    planModule.plugin,
    slideSettingModule.plugin,
    routePrefetchPlugin,
    localStorageABTestPlugin,
    marketplaceRedeemPlugin,
    marketplaceCaptureRenderHoldPlugin,
    skipSlideModule.plugin,
    slideAttributesCachePurgePlugin,
    htmlSlideCachePurgePlugin,
    imageCreditNotesPlugin,
    presetModule.plugin,
    ...audioModule.plugins,
    ...(isEmbedded() ? [embeddablePlugin] : []),
    embedAppPlugin,
    appLoggingPlugin,
  ],
})

export default store
